// ===========================================
// SCHEMA: RegistrarPago
// ===========================================
// Schema Zod para el formulario de registrar pago de vencimiento

import { z } from 'zod'

export const registrarPagoSchema = z.object({
  fecha_pago: z.string().min(1, 'La fecha de pago es requerida'),
  monto_pagado: z.number().min(0, 'El monto no puede ser negativo').max(99999999, 'El monto no puede ser mayor a 99.999.999').nullable().optional(),
  forma_pago: z.string().nullable().optional(),
  referencia_pago: z.string().nullable().optional(),
  observaciones: z.string().nullable().optional(),
})

export type RegistrarPagoFormValues = z.infer<typeof registrarPagoSchema>
